import { createListenerMiddleware } from '@reduxjs/toolkit'
import { AnalyticsEvent } from '@/analytics/schema/events.schema'
import { getUnsupportedTypeRejectedAnalyticsProps } from '@/analytics/utils/unsupported-upload-analytics'
import { getTrackEventGlobal } from '@/analytics/utils/analytics-helpers'
import { UppyFileUploadActions } from '@/uppy-file-upload/store/slice'

export const unsupportedUploadAnalyticsMiddleware = createListenerMiddleware()
const start = unsupportedUploadAnalyticsMiddleware.startListening

start({
  actionCreator: UppyFileUploadActions.unsupportedTypeFileAdded,
  effect: (action) => {
    const track = getTrackEventGlobal()
    if (!track) return

    track(AnalyticsEvent.UserFileUnsupportedTypeRejected, getUnsupportedTypeRejectedAnalyticsProps(action.payload))
  },
})
